import type { SamplePreviewId } from "@/src/lib/pdf/sample-preview-registry";
import {
  sampleChatgptFilename,
  sampleChatgptMarkdown,
  sampleGeminiFilename,
  sampleGeminiMarkdown,
  sampleHomeFilename,
  sampleMarkdown,
  sampleMermaidFilename,
  sampleMermaidMarkdown,
  sampleReadmeFilename,
  sampleReadmeMarkdown,
  sampleTechResumeFilename,
  sampleTechResumeMarkdown,
} from "./constants";

export type EmbeddedSample = {
  markdown: string;
  filename: string;
};

const embeddedSamples: Record<SamplePreviewId, EmbeddedSample> = {
  home: {
    markdown: sampleMarkdown,
    filename: sampleHomeFilename,
  },
  resume: {
    markdown: sampleTechResumeMarkdown,
    filename: sampleTechResumeFilename,
  },
  readme: {
    markdown: sampleReadmeMarkdown,
    filename: sampleReadmeFilename,
  },
  chatgpt: {
    markdown: sampleChatgptMarkdown,
    filename: sampleChatgptFilename,
  },
  gemini: {
    markdown: sampleGeminiMarkdown,
    filename: sampleGeminiFilename,
  },
  mermaid: {
    markdown: sampleMermaidMarkdown,
    filename: sampleMermaidFilename,
  },
};

/** Resolve seed markdown/filename for an embedded converter sample id. */
export function getEmbeddedSample(sampleId: SamplePreviewId): EmbeddedSample {
  return embeddedSamples[sampleId];
}
